import { render, staticRenderFns } from "./otc.vue?vue&type=template&id=49cee7da&scoped=true"
import script from "./otc.vue?vue&type=script&lang=js"
export * from "./otc.vue?vue&type=script&lang=js"
import style0 from "./otc.vue?vue&type=style&index=0&id=49cee7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cee7da",
  null
  
)

export default component.exports